export const styleSheet = () => ({
    container: {
        height: '30px',
        verticalAlign: 'middle'
    }
});
